import AnalyticsList from "./analyticsList";
export default AnalyticsList;
